'use strict'

export const loadmore = (() => {
    const init = () => {
        const VNlocation = document.querySelector('#verified-numbers');
        const VNlocationList = document.querySelector('#verified-numbers-list');
        const VNloadMore = document.querySelector('#loadmore');

        if (VNlocation && VNlocationList && VNloadMore) {
            const VNitems = VNlocationList.querySelectorAll('h1, p')
            const VNparagraph = VNloadMore.querySelector('p')
            const VNicon = VNloadMore.querySelector('svg')
            
            VNloadMore.addEventListener('click', () => {
                if (VNlocationList.classList.contains('active')) {
                    VNlocationList.classList.remove('active')

                    VNparagraph.innerHTML = 'Bekijk alles';
                    VNicon.classList.remove('rotate')

                    VNitems.forEach((VNitem, i) => {
                        if (i > 2) {
                            VNitem.classList.add('hidden');
                        }
                    })
                } else {
                    VNlocationList.classList.add('active')

                    VNparagraph.innerHTML = 'Bekijk minder';
                    VNicon.classList.add('rotate')

                    VNitems.forEach((VNitem) => {
                        VNitem.classList.remove('hidden');
                    })
                }

                VNlocation.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
            })
        }
    }

    return {
        init
    }
})()
